import { defineMessages } from 'react-intl-next';

export default defineMessages({
    newTabText: {
        defaultMessage: 'Opens in new tab',
        description: 'Indicates that the link will open in a new tab',
        id: 'cv.new.tab.tooltip.container',
    },
});
